import React, { useState, useEffect } from "react";
import Footer from "../Components/Footer"; // Import de votre composant Footer
import "./AboutStyles.css";
import Header from "../Components/Header";

function About() {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  
  useEffect(() => {
    setIsVisible(true);
    
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const parallaxOffset = (element) => {
    return {
      transform: `translateY(${scrollY * element}px)`
    };
  };

  return (
    <div className="about-apple-container">
        <Header />

      {/* Hero Section */}
      <div className="about-hero-modern">
        <div className="about-hero-content">
          <h1 className="about-hero-title">Qui sommes-nous ?</h1>
        </div>
        <div className="about-hero-gradient"></div>
      </div>

      {/* Story Section */}
      <div className="about-story-section">
        <div className="about-story-container">
          <div className="about-story-card">
            <div className="about-story-image">
              <img src={require("../img/woody.png")} alt="WoodyBooth Instaloc" />
            </div>
            <div className="about-story-content">
              <h2 className="about-story-title">Notre histoire</h2>
              <p className="about-story-text">
                Instaloc est né de notre collaboration, Gabriel et Marianne, un couple animé par l'exigence technique et l'artisanat. Plutôt que de choisir une solution standardisée, nous avons fait le choix de concevoir et de fabriquer notre propre photobooth. Cette démarche de concepteurs nous a permis d'allier le travail noble du bois et la précision de la menuiserie à une intégration logicielle rigoureuse, garantissant une machine aussi fiable qu'esthétique.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="about-features-section">
        <div className="about-features-container">
          <div className={`about-feature-card ${isVisible ? 'about-apple-fade-in' : ''}`}>
            <div className="about-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="3" width="20" height="14" rx="2" />
                <path d="M8 21h8" />
                <path d="M12 17v4" />
              </svg>
            </div>
            <h3 className="about-feature-title">La qualité d'image</h3>
            <p className="about-feature-text">
              Nous utilisons un système d'impression thermique professionnel (DNP DS620) pour garantir des tirages instantanés avec un rendu professionnel.
            </p>
          </div>

          <div className={`about-feature-card ${isVisible ? 'about-apple-fade-in' : ''}`}>
            <div className="about-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            <h3 className="about-feature-title">La robustesse et le design</h3>
            <p className="about-feature-text">
              Notre conception artisanale est pensée pour s'intégrer élégamment à vos événements, garantissant une installation sécurisée et sans compromis technique.
            </p>
          </div>

          <div className={`about-feature-card ${isVisible ? 'about-apple-fade-in' : ''}`}>
            <div className="about-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 20v-6M6 20V10M18 20V4" />
                <circle cx="12" cy="14" r="2" />
                <circle cx="6" cy="8" r="2" />
                <circle cx="18" cy="2" r="2" />
              </svg>
            </div>
            <h3 className="about-feature-title">Un accompagnement simple et complet</h3>
            <p className="about-feature-text">
              Pour compléter l'expérience autour de la borne, nous proposons également à la location un système de sonorisation ainsi que des effets d'ambiance (machine à fumée et stroboscope). Ce matériel d'appoint est sélectionné suite à vos retours pour apporter une touche festive supplémentaire à vos soirées, en toute simplicité.
            </p>
          </div>

          <div className={`about-feature-card ${isVisible ? 'about-apple-fade-in' : ''}`}>
            <div className="about-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <h3 className="about-feature-title">L'engagement de créateurs</h3>
            <p className="about-feature-text">
              En choisissant Instaloc, vous traitez directement avec les concepteurs de l'outil. Nous maîtrisons chaque aspect technique de notre matériel pour vous assurer une installation fiable et un service de proximité, sans artifice.
            </p>
          </div>
        </div>
      </div>

      {/* Products Section */}
      <div className="about-products-section">
        <div className="about-products-container">
          <h2 className="about-products-title">Découvrez nos produits</h2>

          <div className="about-products-grid">
            <div className="about-product-card">
              <div className="about-product-image">
                <img src={require("../img/woody.png")} alt="WoodyBooth" />
              </div>
              <h3 className="about-product-name">WoodyBooth</h3>
              <p className="about-product-price">200€<span>/jour</span></p>
            </div>

            <div className="about-product-card">
              <div className="about-product-image">
                <img src={require("../img/JBL 710 PNG.webp")} alt="JBL PartyBox 710" />
              </div>
              <h3 className="about-product-name">JBL PartyBox 710</h3>
              <p className="about-product-price">50€<span>/jour</span></p>
            </div>

            <div className="about-product-card">
              <div className="about-product-image">
                <img src={require("../img/Double enceinte JBL 710 PNG.png")} alt="Double JBL 710" />
              </div>
              <h3 className="about-product-name">Double JBL 710</h3>
              <p className="about-product-price">80€<span>/jour</span></p>
            </div>

            <div className="about-product-card">
              <div className="about-product-image">
                <img src={require("../img/Smog Machine PNG.png")} alt="Machine à fumée" />
              </div>
              <h3 className="about-product-name">Machine à fumée</h3>
              <p className="about-product-price">40€<span>/jour</span></p>
            </div>

            <div className="about-product-card">
              <div className="about-product-image">
                <img src={require("../img/Stroboscope PNG.png")} alt="Stroboscope 1500W" />
              </div>
              <h3 className="about-product-name">Stroboscope 1500W</h3>
              <p className="about-product-price">20€<span>/jour</span></p>
            </div>
          </div>
        </div>
      </div>


      {/* Contact CTA */}
      <div className="about-apple-cta-section">
        <div className="about-apple-cta-container">
          <h2 className="about-apple-cta-title">Prêts à créer des souvenirs ensemble?</h2>
          <p className="about-apple-cta-description">
            Chaque événement est unique. Nous serions ravis de donner vie au vôtre avec notre photobooth artisanal.
          </p>
         <a href="/book"> <button className="about-apple-cta-button">
           Réserver
          </button></a>
        </div>
      </div>
      
      {/* Intégration de votre composant Footer */}
      <Footer />
    </div>
  );
}

export default About;